import pagination from '../../utils/pagination'
import {
  LOTS_FETCH_MANY_REQUEST, LOTS_FETCH_MANY_SUCCESS, LOTS_FETCH_MANY_FAILURE,
  LOTS_FETCH_REQUEST, LOTS_FETCH_SUCCESS, LOTS_FETCH_FAILURE,
  LOTS_SAVE_REQUEST, LOTS_SAVE_SUCCESS, LOTS_SAVE_FAILURE,
  EMPTY_LOTS,
  CLEAR_ERRORS
} from './types'

export default {
  [LOTS_FETCH_MANY_REQUEST] (state) {
    state.data = []
    state.loading = true
  },
  [LOTS_FETCH_MANY_SUCCESS] (state, { data }) {
    state.data = data.data
    state.page = pagination(data)
    state.loading = false
  },
  [LOTS_FETCH_MANY_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.loading = false
  },
  [LOTS_FETCH_REQUEST] (state) {
    state.single = {}
    state.loading = true
  },
  [LOTS_FETCH_SUCCESS] (state, { data }) {
    state.single = data
    state.loading = false
  },
  [LOTS_FETCH_FAILURE] (state) {
    state.loading = false
  },
  [LOTS_SAVE_REQUEST] (state) {
    state.data = []
    state.saving = true
  },
  [LOTS_SAVE_SUCCESS] (state) {
    state.saving = false
  },
  [LOTS_SAVE_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.saving = false
  },
  [EMPTY_LOTS] (state) {
    state.data = []
    state.loading = false
    state.saving = false
  },
  [CLEAR_ERRORS] (state) {
    state.validationErrors = []
    state.loading = false
    state.saving = false
  }
}
